import moment from 'moment';

$(document).ready(function() {

    let translations = {},
        locale = 'en';

    if($('#alert-modal').length){
        translations = JSON.parse($('#alert-modal').attr('data-translations'));
        locale = $('#alert-modal').attr('data-lang');
    }

    $('.alert-input').on('focus', function (e) {
        let $field = $(this),
            field_id = $(this).attr('id'),
            event_options = JSON.parse($(this).attr('data-event-options')),
            alert_types = JSON.parse($(this).attr('data-alert-types')),
            payload = $field.next('input').val();

        $('#save-alert').attr('data-action', 'creating');

        $('#alert-modal')
            .attr('data-field-id', field_id)
            .modal('show');

        if(payload.length){
            payload = JSON.parse(payload);
        }else{
            payload = false;
        }

        let events = {
            at_event : translations.at_event,
            minutes_before : translations.minutes_before,
            hours_before : translations.hours_before,
            days_before : translations.days_before,
            minutes_after : translations.minutes_after,
            hours_after : translations.hours_after,
            days_after : translations.days_after,
            on_date : translations.on_date,
            at : translations.at
        };

        let types = {
            notification : translations.notification,
            sms : translations.sms,
            email : translations.email,
            message : translations.message,
        };

        $('#alert-type').empty();
        $('#event-option').empty();

        alert_types.forEach(function(value){
            let option = `<option value="${value}">${types[value]}</option>`;
            $('#alert-type').append(option);
        });

        event_options.forEach(function(value){
            let option = `<option value="${value}">${events[value]}</option>`;
            $('#event-option').append(option);
        });

        $('.selectpicker').selectpicker('refresh');

        if(payload){
            $('#default-value').val(payload.default_value).attr('value', payload.default_value);
            $('#alert-type').val(payload.alert_type).trigger('change');
            $('#event-option').val(payload.option).trigger('change');
            $('#remove-alert').removeClass('d-none');
        }else{
            $('#event-option').trigger('change');
        }
    });

    $('#event-option').on('change', function(e){
        let $value_holder = $('.default-value-holder'),
            $default_value = $('#default-value'),
            value = $default_value.val(),
            option = $(this).val();


        let $modal = $('#alert-modal'),
            field_id = $modal.attr('data-field-id'),
            $field = $(".alert-input[data-id='"+field_id+"']"),
            default_value = $field.attr('data-default-value');

        if(option.length && option !== 'at_event'){
            $value_holder.removeClass('d-none');

            let default_date = $default_value.val();
            if(!isNaN(default_date)){
                default_date = moment().format('YYYY-MM-DD HH:mm');
            }

            if(option === 'on_date') {
                $('#default-value').flatpickr({
                    weekNumbers: true,
                    dateFormat: 'Y-m-d' + " H:i",
                    enableTime: true,
                    time_24hr: true,
                    defaultDate: default_date,
                    onChange: function (selectedDates, dateStr, instance) {
                        $(instance.element).attr('value', dateStr);
                    },
                });
            }else{
                $('#default-value').flatpickr().destroy();
                $('#default-value').val(default_value).trigger('keyup');
            }
        }else{
            $('#default-value').flatpickr().destroy();
            $('#default-value').val(default_value).trigger('keyup');
            $value_holder.addClass('d-none');
        }
    });

    $('#save-alert').on('click', function(e){
        e.preventDefault();

        let $modal = $('#alert-modal'),
            alert_type = $('#alert-type').val(),
            option = $('#event-option').val(),
            default_value = $('#default-value').val(),
            field_id = $modal.attr('data-field-id'),
            $field = $(".alert-input[data-id='"+field_id+"']"),
            action = $(this).attr('data-action');

        let payload = {
            option,
            alert_type,
            default_value
        };

        if(option && option.length && alert_type && alert_type.length){
            if(option !== 'at_event'){
                if(!default_value.length){
                    alert(translations.provide_default_value);
                    return;
                }
            }
        }else{
            alert(translations.select_alert_event);
            return;
        }

        if(action === 'creating'){
            $field.val(getAlertPayloadTitle(payload)).trigger('keyup');
            $field.next('input').val(JSON.stringify(payload)).trigger('keyup');
            $field.closest('.form-group').addClass('control-highlight');
        }else{
            let $editable = $(`#${field_id}`);

            if(!$editable.attr('data-old-value')){
                $editable.attr('data-old-value', $editable.attr('data-value'));
                $editable.attr('data-old-text', $editable.find('a').find('span').text().trim());
            }

            $editable.attr('data-value', JSON.stringify(payload));
            $editable.find('a').find('span').text(getAlertPayloadTitle(payload));
            $editable.addClass('update');
            $('.edit-buttons').removeClass('d-none');
        }

        $('#remove-alert').removeClass('d-none');
        $modal.modal('hide');
    });

    $('body').on('click', '#remove-alert', function(e){
        let $modal = $('#alert-modal'),
            field_id = $modal.attr('data-field-id'),
            $field = $(".alert-input[data-id='"+field_id+"']"),
            action = $(this).attr('data-action');


        if(action === 'creating'){
            $field.val('');
            $field.next('input').val('');
            $field.closest('.form-group').removeClass('control-highlight');
        }else{
            let $editable = $(`#${field_id}`);
            $editable.attr('data-value', '');
            $editable.find('a').find('span').text('None');
            $editable.addClass('update');
            $('.edit-buttons').removeClass('d-none');
        }

        $('#remove-alert').addClass('d-none');
        $modal.modal('hide');

        $('#alert-type').val('');
        $('#event-option').val('');
        $('#default-value').val('');
        $('.default-value-holder').addClass('d-none');
    });

    function getAlertPayloadTitle(payload){
        let value = 'None';
        if(payload.option){
            switch (payload.option) {
                case 'at_event':
                    value = 'At the time of the event';
                    break;
                case 'minutes_before':
                    value = payload.default_value + ' Minutes Before';
                    break;
                case 'hours_before':
                    value = payload.default_value + ' Hours Before';
                    break;
                case 'days_before':
                    value = payload.default_value + ' Days Before';
                    break;
                case 'minutes_after':
                    value = payload.default_value + ' Minutes After';
                    break;
                case 'hours_after':
                    value = payload.default_value + ' Hours After';
                    break;
                case 'days_after':
                    value = payload.default_value + ' Days After';
                    break;
                case 'on_date':
                    let date = moment(payload.default_value).locale(locale).format("ddd, D MMM");
                    date = date.replace(/\./g,'')
                    value =  date + ` ${translations.at} ` + moment(payload.default_value).format("H:mm");
                    break;
            }
        }
        return value;
    }
});